<template>
    <div class="card">
        <div class="card-body py-3">
            <h3>Fees</h3>
            {{ $route.query.source_type }}
            <div v-if="$route.query.source_type === 'PMP'">
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_spa_legal_fee === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="ml-2">S&amp;P Legal Fee</span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_loan_legal_fee === 'Include'"><i class="fa fa-check"></i></span>
                        <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="ml-2">Loan Legal Fee</span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_loan_stamp_duty === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="ml-2">Loan Stamp</span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_mot === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="ml-2">MOT Fee</span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_sinking_fund === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="mx-2">Sinking Fund</span>
                    <span class="px-2 rounded font-weight-600 text-success" style="background: #E6FFEA;" v-if="fees.fees_sinking_fund === 'Include'">
                        RM {{fees.fees_sinking_fund_amt}} sqft
                    </span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_maintenance === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="mx-2">Maintenance</span>
                    <span class="px-2 rounded font-weight-600 text-success" style="background: #E6FFEA;" v-if="fees.fees_maintenance === 'Include'">
                        RM {{fees.fees_maintenance_amt}} sqft
                    </span>
                </div>
                <div class="mb-2">
                    <span class="text-success" v-if="fees.fees_valuation_fee === 'Include'"><i class="fa fa-check"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times"></i></span>
                    <span class="mx-2">Valuation</span>
                    <span class="px-2 rounded font-weight-600 text-success text-xs" style="background: #E6FFEA;" v-if="fees.fees_valuation_fee === 'Include'">
                        RM {{fees.fees_valuation_fee_amt}} sqft
                    </span>
                </div>
                <hr class="my-3">
                <b-row class="mx-0 pb-3">
                    <b-col cols="auto" class="text-center font-weight-600" style="background: #F6F9FD">{{ fees.track_max_person_reserve }}</b-col>
                    <b-col cols="auto">Max Reserve</b-col>
                </b-row>
                <b-row class="mx-0 pb-3">
                    <b-col cols="auto" class="text-center font-weight-600" style="background: #F6F9FD">{{fees.cb_percent_to_customer}}%</b-col>
                    <b-col cols="auto">Buyer Discount</b-col>
                </b-row>
            </div>

            <div v-else-if="$route.query.source_type === 'HESTIA'">
                <div class="row mt-4">
                    <div class="col-12 mb-3 d-flex align-items-center">
                        <span class="mx-2 text-md">Booking Amount</span>
                        <div class="rounded text-xs text-success px-2 py-1" style="background: #E6FFEA;">
                            <span class="font-weight-600">RM {{ fees.fees_booking_amount | moneyFormatter }}</span>
                        </div>
                    </div>
                    <div class="col-12 mb-3 d-flex align-items-center">
                        <span class="mx-2 text-md">Deposit Amount</span>
                        <div class="rounded text-xs text-success px-2 py-1" style="background: #E6FFEA;">
                            <span class="font-weight-600">RM {{ fees.fees_deposit_amount | moneyFormatter }}</span>
                        </div>
                    </div>
                    <div 
                        v-for="(fee, key) in feeStatuses" 
                        :key="key" 
                        class="col-12 mb-3 d-flex align-items-center"
                    >
                        <span v-html="fee.status ? check : xmark"></span> 
                        <span class="mx-2 text-md">{{ feeLabels[key] }}</span>
                        <div v-if="fee.status" 
                            class="rounded text-xs px-2 py-1" 
                            :style="getStatusStyle(fee.status)"
                            :class="getTextClass(fee.status)"
                        >
                            <span>{{ fee.status }}</span>
                            <span class="ml-2 font-weight-600">RM {{ fee.amount | moneyFormatter }}</span>
                        </div>
                    </div>
                </div>
                <hr class="mt-1 mb-3"/>
                <div class="row">
                    <div class="col-12 d-flex align-items-center pb-3">
                        <div class="rounded px-3 py-1 text-md font-weight-600" style="background: #F6F9FD">{{ fees.bumi_discount_percent }}%</div>
                        <span class="mx-2 text-md">Bumi Discount</span>
                    </div>
                    <div 
                        v-for="(discount, index) in fees.other_discounts" 
                        :key="index" 
                        class="col-12 d-flex align-items-center pb-3"
                    >
                        <div class="rounded px-3 py-1 text-md font-weight-600" style="background: #F6F9FD">RM {{ discount.amount }}</div>
                        <span class="mx-2 text-md">{{ discount.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['fees'],
    data() {
        return {
            check: '<svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="16" height="16" viewBox="0 0 448 512"><path fill="#0BC196" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>',
            xmark: '<svg xmlns="http://www.w3.org/2000/svg" class="text-danger" width="16" height="16" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256z"/></svg>',
        }
    },
    computed: {
        feeStatuses() {
            return {
                fees_spa_legal_fee_status: {
                    status: this.fees?.fees_spa_legal_fee_status,
                    amount: this.fees?.fees_spa_legal_fee_amount
                },
                fees_loan_stamp_duty_status: {
                    status: this.fees?.fees_loan_stamp_duty_status,
                    amount: this.fees?.fees_loan_stamp_duty_amount
                },
                fees_maintenance_status: {
                    status: this.fees?.fees_maintenance_status,
                    amount: this.fees?.fees_maintenance_amount
                },
                fees_spa_disb_status: {
                    status: this.fees?.fees_spa_disb_status,
                    amount: this.fees?.fees_spa_disb_amount
                },
                fees_spa_stamp_duty_status: {
                    status: this.fees?.fees_spa_stamp_duty_status,
                    amount: this.fees?.fees_spa_stamp_duty_amount
                },
                fees_loan_legal_fee_status: {
                    status: this.fees?.fees_loan_legal_fee_status,
                    amount: this.fees?.fees_loan_legal_fee_amount
                },
                fees_loan_disb_status: {
                    status: this.fees?.fees_loan_disb_status,
                    amount: this.fees?.fees_loan_disb_amount
                },
                fees_mot_status: {
                    status: this.fees?.fees_mot_status,
                    amount: this.fees?.fees_mot_amount
                },
                fees_valuation_status: {
                    status: this.fees?.fees_valuation_status,
                    amount: this.fees?.fees_valuation_amount
                },
                fees_sinking_status: {
                    status: this.fees?.fees_sinking_status,
                    amount: this.fees?.fees_sinking_amount
                }
            };
        },
        feeLabels() {
            return {
                fees_spa_legal_fee_status: 'SPA Legal Fee',
                fees_loan_stamp_duty_status: 'Loan Stamp Duty',
                fees_maintenance_status: 'Maintenance',
                fees_spa_disb_status: 'SPA Disbursement',
                fees_spa_stamp_duty_status: 'SPA Stamp Duty',
                fees_loan_legal_fee_status: 'Loan Legal Fee',
                fees_loan_disb_status: 'Loan Disbursement',
                fees_mot_status: 'Memorandum of Transfer',
                fees_valuation_status: 'Valuation',
                fees_sinking_status: 'Sinking Fund'
            };
        }
    },
    methods: {
        getStatusStyle(status) {
            if (status === 'Paid by Developer') {
                return { background: '#FFF3F3' }
            } else if (status === 'Paid by Client' || 'Finance into loan') {
                return { background: '#E6FFEA' }
            }
            return {}; // Default style
        },
        getTextClass(status) {
            if (status === 'Paid by Developer') {
                return 'text-danger' 
            } else if (status === 'Paid by Client' || 'Finance into loan') {
                return 'text-success'
            }
            return ''; // Default style
        }
    }
}
</script>